import { Directive, ElementRef, HostListener, OnInit, inject } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
  selector: '[tooltipIfTruncated]',
  standalone: true
})
export class TooltipIfTruncatedDirective implements OnInit {
  private readonly element = inject(ElementRef<HTMLElement>);
  private readonly tooltip = inject(MatTooltip, { self: true });

  ngOnInit(): void {
    this.tooltip.disabled = true;
  }

  @HostListener('mouseenter')
  @HostListener('focus')
  updateTooltip(): void {
    const element = this.element.nativeElement;
    this.tooltip.disabled = element.scrollWidth <= element.clientWidth;

    if (!this.tooltip.disabled) {
      this.tooltip.show();
    }
  }
}
